import { GATSBY_CDN_URL } from './env';
export function getCdnUrl(url: string) {
  return `${GATSBY_CDN_URL}/infcon/infcon-2024/${url}`;
}
